(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["breezer-lucimora-product"] && !Shopify.designMode) return;
  try {
    
  const blpSections = document.querySelectorAll('.blp[data-section-id]');
  blpSections.forEach((section) => {
    if (section.dataset.breezerBound === 'true') return;
    section.dataset.breezerBound = 'true';
    const sectionId = section.dataset.sectionId;
    const data = document.getElementById(`BreezerVariants-${sectionId}`);
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const form = section.querySelector('.blp__form');
    const idInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const add = section.querySelector('[data-add-to-cart]');
    const message = section.querySelector('[data-form-message]');
    const money = (value) => new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'JPY', maximumFractionDigits: 0 }).format(value / 100);
    const sync = () => {
      const selected = [...section.querySelectorAll('.blp__option')].map((group) => group.querySelector('input:checked')?.value || '');
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      section.querySelectorAll('.blp__value').forEach((label) => label.classList.toggle('is-selected', label.querySelector('input').checked));
      section.querySelectorAll('[data-selected-option]').forEach((target, index) => { target.textContent = selected[index] || ''; });
      if (!variant) return;
      idInput.value = variant.id;
      price.textContent = money(variant.price);
      if (variant.compare_at_price > variant.price) { compare.textContent = money(variant.compare_at_price); compare.hidden = false; } else { compare.hidden = true; }
      add.disabled = !variant.available;
      add.querySelector('[data-add-text]').textContent = variant.available ? add.dataset.availableText || 'カートに追加' : '売り切れ';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    section.querySelectorAll('.blp__option input').forEach((input) => input.addEventListener('change', sync));
    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { const input = section.querySelector('[name="quantity"]'); input.value = Math.max(1, Number(input.value || 1) - 1); });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { const input = section.querySelector('[name="quantity"]'); input.value = Number(input.value || 1) + 1; });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      message.textContent = '';
      add.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(idInput.value), quantity: Number(form.querySelector('[name="quantity"]').value || 1) }) });
        if (!response.ok) throw new Error('Could not add product');
        window.location.href = '/cart';
      } catch (error) {
        message.textContent = 'カートに追加できませんでした。もう一度お試しください。';
        add.disabled = false;
      }
    });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breezer-product-jp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-bp-section]').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';
      const id = section.dataset.bpSection;
      const data = document.getElementById(`BreezerProductVariants-${id}`);
      if (!data) return;
      const variants = JSON.parse(data.textContent);
      const idInput = section.querySelector('[data-variant-id]');
      const price = section.querySelector('[data-price]');
      const compare = section.querySelector('[data-compare-price]');
      const submit = section.querySelector('[data-submit]');
      const money = (value) => new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', maximumFractionDigits: 0 }).format(value / 100);
      const sync = () => {
        const selected = [...section.querySelectorAll('[data-option-index]')].map((group) => group.querySelector('input:checked')?.value || '');
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
        section.querySelectorAll('.bp__value').forEach((label) => label.classList.toggle('is-selected', label.querySelector('input').checked));
        if (!variant) return;
        idInput.value = variant.id;
        price.textContent = money(variant.price);
        if (variant.compare_at_price > variant.price) { compare.textContent = money(variant.compare_at_price); compare.hidden = false; } else { compare.hidden = true; }
        submit.disabled = !variant.available;
        submit.querySelector('[data-submit-text]').textContent = variant.available ? 'カートに追加' : '売り切れ';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      section.querySelectorAll('[data-option-index] input').forEach((input) => input.addEventListener('change', sync));
      section.querySelectorAll('[data-bp-media-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        const target = thumb.dataset.bpMediaThumb;
        section.querySelectorAll('[data-bp-media-thumb]').forEach((item) => { const active = item === thumb; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', active ? 'true' : 'false'); });
        section.querySelectorAll('[data-bp-media-panel]').forEach((panel) => { const active = panel.dataset.bpMediaPanel === target; panel.hidden = !active; panel.classList.toggle('is-active', active); });
      }));
      section.querySelector('[data-minus]')?.addEventListener('click', () => { const input = section.querySelector('[name="quantity"]'); input.value = Math.max(1, Number(input.value || 1) - 1); });
      section.querySelector('[data-plus]')?.addEventListener('click', () => { const input = section.querySelector('[name="quantity"]'); input.value = Number(input.value || 1) + 1; });
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breezer-product-rich"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.breezer-rich').forEach((section)=>{if(section.dataset.richBound)return;section.dataset.richBound='true';section.querySelectorAll('[data-rich-thumb]').forEach((thumb)=>thumb.addEventListener('click',()=>{const target=thumb.dataset.richThumb;section.querySelectorAll('[data-rich-thumb]').forEach((item)=>{const active=item===thumb;item.classList.toggle('is-active',active);item.setAttribute('aria-pressed',active?'true':'false')});section.querySelectorAll('[data-rich-panel]').forEach((panel)=>{const active=panel.dataset.richPanel===target;panel.hidden=!active;panel.classList.toggle('is-active',active)})}))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
